import { FormattedMessage, type IntlShape } from 'react-intl'

import { type PublicGlobalConfig } from '../../global-config'
import {
  urlResolverGetAccount,
  urlResolverGetFaqItemCancelOrder,
  urlResolverGetFaqItemDeliveryInfo,
  urlResolverGetFaqItemPaymentMethods,
  urlResolverGetFaqItemRedeemVoucher,
  urlResolverGetFaqItemReturnOrder,
  urlResolverGetFaqitemShippingCost,
} from '../../url-handling'

import { type ContactPageFaqCard } from './ContactPageFaqCardsSectionCard'
import { ContactPageFaqCardsSectionCardTextLink } from './ContactPageFaqCardsSectionCardTextLink'

const CONTACT_PAGE_FAQ_CARDS = {
  cancelOrder: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage
        id="contact.faqCardsSection.firstCard.description"
        values={{
          accountAnchor: (chunks) => (
            <ContactPageFaqCardsSectionCardTextLink
              href={urlResolverGetAccount(config)}
            >
              {chunks}
            </ContactPageFaqCardsSectionCardTextLink>
          ),
        }}
      />
    ),
    href: urlResolverGetFaqItemCancelOrder(config),
    title: intl.formatMessage({
      id: 'account.messageReason.subject.cancelOrder',
    }),
  }),

  deliveryInfo: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage id="contact.faqCardsSection.thirdCard.description" />
    ),
    href: urlResolverGetFaqItemDeliveryInfo(config),
    title: intl.formatMessage({
      id: 'buyBox.delivery.shippingMethod.bpostHome',
    }),
  }),

  paymentMethods: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage id="contact.faqCardsSection.sixthCard.description" />
    ),
    href: urlResolverGetFaqItemPaymentMethods(config),
    title: intl.formatMessage({
      id: 'contact.faqCardsSection.sixthCard.title',
    }),
  }),

  redeemVoucher: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage id="contact.faqCardsSection.seventhCard.description" />
    ),
    href: urlResolverGetFaqItemRedeemVoucher(config),
    title: intl.formatMessage({
      id: 'general.link.label.vouchers',
    }),
  }),

  returnOrder: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage id="contact.faqCardsSection.fifthCard.description" />
    ),
    href: urlResolverGetFaqItemReturnOrder(config),
    title: intl.formatMessage({
      id: 'contact.faqCardsSection.fifthCard.title',
    }),
  }),
  shippingCost: (
    config: PublicGlobalConfig,
    intl: IntlShape,
  ): ContactPageFaqCard => ({
    description: (
      <FormattedMessage
        id="contact.faqCardsSection.secondCard.description"
        values={{
          highlightedText: (chunks) => (
            <span className="font-medium italic text-dark-brand">{chunks}</span>
          ),
        }}
      />
    ),
    href: urlResolverGetFaqitemShippingCost(config),
    title: intl.formatMessage({
      id: 'freeShippingIndicator.label.shippingCost',
    }),
  }),
}

export const contactPageGetFaqCards = (
  config: PublicGlobalConfig,
  intl: IntlShape,
): ContactPageFaqCard[] => [
  CONTACT_PAGE_FAQ_CARDS.deliveryInfo(config, intl),
  CONTACT_PAGE_FAQ_CARDS.returnOrder(config, intl),
  CONTACT_PAGE_FAQ_CARDS.cancelOrder(config, intl),
  CONTACT_PAGE_FAQ_CARDS.paymentMethods(config, intl),
  CONTACT_PAGE_FAQ_CARDS.shippingCost(config, intl),
  CONTACT_PAGE_FAQ_CARDS.redeemVoucher(config, intl),
]
